// extracted by mini-css-extract-plugin
module.exports = {"label":"_4179308","search":"_e16a39b","inputWrapper":"_ecd6ecd","input":"_a976cdb","iconWrapper":"_69eaa3c","clearIcon":"_6ea3b15","searchIcon":"_24b94b6"};